import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';

function ASNTable(props) {

    const columns = [
        {
            field: 'Sku',
            headerName: 'SKU',
            flex: 1,
            maxWidth: 200,
            editable: false
        },
        {
            field: 'Description',
            headerName: 'Description',
            flex: 1,
            minWidth: 200,
            editable: false
        }, 
        {
            field: 'Qty',
            headerName: 'Ordered Qty',
            flex: 1,
            headerAlign: 'center', 
            align: 'center', 
            maxWidth: 100,
            editable: false
        }, 
        {
            field: 'Shipped',
            headerName: 'On Shipments',
            flex: 1,
            headerAlign: 'center', 
            align: 'center', 
            maxWidth: 120,
            editable: false
        }, 
        {
            field: "fulfilled",
            headerName: "Mark Total Fulfilled",
            minWidth: 200,
            headerAlign: 'center', 
            align: 'center', 
            renderCell: params => {
                return (
                    <Box display = "flex" style = {{ width: "fit-content", height: "fit-content" }}>
                        <Button 
                            // onClick = {() => decrementPartial("partial" + index, row)} 
                            variant = "outlined" 
                            color = "error" 
                            style = {{
                                borderBottomRightRadius: "0", 
                                borderTopRightRadius: "0", 
                                fontSize: "24px", 
                                height : "30px", 
                                width: "12px"
                            }}
                        >
                            -
                        </Button>
                        <Box style = {{ margin: "auto", fontSize: "16px", padding: "8px" }}>
                            {params.row.Qty}
                        </Box>
                        <Button 
                            // onClick = {() => incrementPartial("partial" + index, row)} 
                            variant = "outlined" 
                            color = "success" 
                            style = {{ 
                                fontSize: "24px", 
                                height: "30px", 
                                width: "12px", 
                                borderBottomLeftRadius: "0", 
                                borderTopLeftRadius: "0"
                            }}
                        >
                            +
                        </Button>
                    </Box>
                );
            }
        },
        {
            field: "set_value",
            headerName: "Set Value",
            minWidth: 120,
            headerAlign: 'center', 
            align: 'center', 
            renderCell: params => {
                return (
                    <Button 
                        variant = "contained" 
                        style = {{ width: '95px' }}  
                        // onClick = {() => setShortItemInfo(params.row)} 
                        disabled = {props.selectedOrder?.vendor_status === 301 ? true : false}>
                            Set Value
                    </Button> 
                );
            }
        }
        // {
        //     field: 'ShippedQty',
        //     headerName: 'Set Value',
        //     flex: 1,
        //     minWidth: 50,
        //     editable: false
        // }, 
        
    ];

    return (
        <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
            <DataGrid
                className = {props.isMobile ? "mobile-table" : "desktop-table"}
                sx = {{ 
                    height: "50%",
                    width: '90%'
                }}
                
                rows = {props.items}
                getRowId = {(row) => row.id}
                columns = {columns}
                rowsPerPageOptions = {[25, 50, 100]}
                checkboxSelection = {false}
            />
            <Button onClick = {props.submitBuilds} sx = {{ ml: '10px', mt: '10px' }} disabled = {props.loading} variant = "contained" color = "primary">
                Submit Builds 
            </Button>
        </Box>
    );
};

export default ASNTable;